import { Box, Drawer, Toolbar, List } from '@mui/material';

import { StyledDrawerWrapper } from '../style';
import PatientInfo from '../DisplayInformation/PatientInfo';

interface Props {
  name?: string;
  college_ci?: string;
  college_name?: string;
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
  coachRefA: any;
  coachRefB: any;
}

const MenuDrawer = (props: Props) => {
  const {
    name,
    college_ci,
    college_name,
    menuDrawerWidth,
    setMenuDrawerWidth,
    coachRefA,
    coachRefB,
  } = props;

  return (
    <Drawer
      open
      variant="permanent"
      sx={{ width: menuDrawerWidth }}
      // 환자 인포쪽 스크롤 막을거면 overflow hidden하면됨.
      PaperProps={{ sx: { width: 'inherit' } }}
    >
      <StyledDrawerWrapper>
        <Toolbar
          sx={{ height: '68px !important', backgroundColor: '#B1CCF5' }}
        ></Toolbar>

        <List ref={coachRefA}>
          <PatientInfo
            menuDrawerWidth={menuDrawerWidth}
            setMenuDrawerWidth={setMenuDrawerWidth}
          />
        </List>
      </StyledDrawerWrapper>
    </Drawer>
  );
};

export default MenuDrawer;
